// # services
import { auth } from "@/services";

(function (angular) {
  "use strict";

  angular.module("app").controller("eventsController", eventsController);

  eventsController.$inject = [
    "$location",
    "PostsSearchApi",
    "eventsPayload",
    "EventsApi",
    "Events",
    "Helpers",
    "$scope",
  ];

  function eventsController(
    $location,
    PostsSearchApi,
    eventsPayload,
    EventsApi,
    Events,
    Helpers,
    $scope,
  ) {
    const vm = this;
    vm.limit = 6;
    const nowISO = window.moment().format(Helpers.isoFormat);
    // properties
    vm.permissionChecks = {
      canCreateEvents: auth.hasPermission("events.create"),
    };
    vm.categories = []
      .concat($location.search()["categories[]"] || [])
      .map((id) => parseInt(id));
    vm.events = angular.copy(eventsPayload);
    vm.events.data = [];
    vm.isLoading = true;
    vm.showingCalendar = false;

    vm.searchEvents = searchEvents;
    vm.filters = {
      "categories[]": vm.categories,
      is_parent: true,
      page: 1,
      starts_at_from: new Date(),
      ends_at_from: null,
      status: "approved",
      limit: vm.limit,
      page_size: vm.limit,
    };
    vm.orderFilters = {
      ascending: {
        label: "Ascending",
        sort: "starts_at",
        order: "asc",
      },
      descending: {
        label: "Descending",
        sort: "starts_at",
        order: "desc",
      },
      happening_soon: {
        label: "Happening Soon",
        sort: "starts_at",
        order: "Happening Soon",
      },
    };
    vm.selectedOrderFilter = vm.orderFilters.ascending;

    // methods
    vm.onCategoryChange = onCategoryChange;
    vm.getEvents = getEvents;
    vm.orderEvents = orderEvents;
    vm.createEvent = createEvent;

    vm.getEvents();

    /**
     * Initialises the controller.
     *
     * @returns {void}
     */
    function bootstrap(): void {
      // Convert DOM payload events to resource models
      angular.forEach(eventsPayload.data, (event) => {
        vm.events.data.push(new EventsApi(event).transform());
      });
    }
    /**
     * Called when categories have changed.
     * @param categories
     */
    function onCategoryChange(categories: string[]): void {
      vm.categories = categories;
      vm.filters["categories[]"] = categories;

      vm.getEvents();
    }

    function searchEvents() {
      if (!vm.filters.search || vm.filters.search === "") {
        vm.getEvents();
        return;
      }

      vm.isLoading = true;

      // vm.$location.search('categories[]')
      PostsSearchApi.get(
        { q: vm.filters.search, type: "event" },
        (response: any) => {
          vm.events.data = response.results;
          vm.isLoading = false;
          $("html, body").animate({
            scrollTop: $("#events-title").offset().top - 20,
          });
        },
        () => (this.isLoading = false),
      );
    }

    /**
     * Retrieves events from the API
     * @return {void}
     */
    function getEvents() {
      vm.isLoading = true;
      EventsApi.get(
        vm.filters,
        (response) => {
          vm.events = response;
          vm.isLoading = false;
        },
        (error) => {
          vm.isLoading = false;
        },
      );
    }

    /**
     * Updates filters and refreshes the events.
     * Called by the order events select control.
     *
     * @return {void}
     */
    function orderEvents() {
      angular.merge(vm.filters, vm.selectedOrderFilter);
      vm.filters.label = null;
      getEvents();
    }
    $scope.loadMore = function () {
      vm.limit = vm.limit + 3;
      vm.filters.limit = vm.limit;
      vm.filters.page_size = vm.limit;
      vm.getEvents();
    };

    $scope.toggleCalendar = function () {
      vm.showingCalendar = !vm.showingCalendar;
    };

    /**
     * Calls create event service, and appends new event to the page
     * @return {void}
     */
    function createEvent() {
      Events.create();
    }

    bootstrap();
  }
})(angular);
